/**
 * Maps ClinicMetricSummary.metricKey → ClinicEvent.eventType
 * Most metric keys are plural versions of event types.
 * This map handles the ones that differ.
 */
const metricToEventTypeMap: Record<string, string> = {
  appointments_created: 'appointment_created',
  appointments_checked_in: 'appointment_checked_in',
  appointments_checked_out: 'appointment_checked_out',
  encounters_created: 'encounter_created',
  encounters_signed: 'encounter_signed',
  voice_to_chart_uses: 'voice_to_chart_used',
  pcp_initial_reports: 'pcp_initial_report_created',
  pcp_interim_reports: 'pcp_interim_report_created',
  pcp_release_reports: 'pcp_release_report_created',
  ccs_completed: 'ccs_completed',
  ccs_sent: 'ccs_sent',
  post_care_surveys_sent: 'post_care_survey_sent',
  post_care_surveys_completed: 'post_care_survey_completed',
  purchases_created: 'purchase_created',
  claims_sent: 'claim_sent',
  claims_accepted: 'claim_accepted',
  payments_collected: 'payment_collected',
  eras_uploaded: 'era_uploaded',
  npi_rejections: 'npi_rejection',
  enrollment_rejections: 'enrollment_rejection',
  format_837_rejections: 'format_837_rejection',
  provider_loop_errors: 'provider_loop_error',
  referring_provider_errors: 'referring_provider_error',
  condition_references_accessed: 'condition_reference_accessed',
  condition_references_edited: 'condition_reference_edited',
  clinical_evaluations_accessed: 'clinical_evaluation_accessed',
  treatment_techniques_accessed: 'treatment_technique_accessed',
  marketing_campaigns_accessed: 'marketing_campaign_accessed',
  forms_library_downloads: 'forms_library_downloaded',
  research_reviews_accessed: 'research_review_accessed',
  patients_created: 'patient_created',
  condition_reports_sent: 'condition_report_sent',
  condition_reports_opened: 'condition_report_opened',
  google_review_links_sent: 'google_review_link_sent',
  clinic_logo_added: 'clinic_logo_added',
  facebook_linked: 'facebook_linked',
  google_review_url_added: 'google_review_url_added',
  billing_info_added: 'billing_info_added',
  commercial_numbers_added: 'commercial_numbers_added',
  features_suggested: 'feature_suggested',
  features_voted: 'feature_voted',
  knowledge_base_accessed: 'knowledge_base_accessed',
  healthcom_logins: 'healthcom_login',
  active_users: 'heartbeat',
  active_time_minutes: 'heartbeat',
  session_count: 'heartbeat',
  plan_changes: 'plan_changed',
  user_role_changes: 'user_role_changed',
  users_removed: 'user_removed_from_clinic',
};

export const metricKeyToEventType = (metricKey: string): string => {
  return metricToEventTypeMap[metricKey] || metricKey;
};
